import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import SettingsToggle from "../../components/SettingsToggle";
import { FaBars, FaTimes } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";

function Nav() {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/" || location.pathname === "/about";
    return location.pathname.startsWith(path);
  };

  const navItems = [
    {
      path: "/",
      label: "About",
      color: "yellow",
      icon: (
        <svg className="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
          <path fillRule="evenodd" d="M15.5 3.3a1 1 0 0 0-1.4 0l-2 2h.1l6.5 6.5 2-1.9c.4-.4.4-1 0-1.4l-5.2-5.2ZM7 8.3l3.9-1.5 6.3 6.3-1.5 3.9a1 1 0 0 1-.6.6l-9.5 3.3a1 1 0 0 1-1-.1l6.5-6.5A1 1 0 0 0 9.7 13l-6.5 6.4a1 1 0 0 1-.1-1L6.4 9c.1-.3.3-.5.6-.6Z" clipRule="evenodd" />
        </svg>
      )
    },
    {
      path: "/projects",
      label: "Projects",
      color: "purple",
      icon: (
        <svg className="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
          <path fillRule="evenodd" d="M4.9 3C3.9 3 3 3.8 3 4.9V9c0 1 .8 1.9 1.9 1.9H9c1 0 1.9-.8 1.9-1.9V5c0-1-.8-1.9-1.9-1.9H5Zm10 0c-1 0-1.9.8-1.9 1.9V9c0 1 .8 1.9 1.9 1.9H19c1 0 1.9-.8 1.9-1.9V5c0-1-.8-1.9-1.9-1.9h-4Zm-10 10c-1 0-1.9.8-1.9 1.9V19c0 1 .8 1.9 1.9 1.9H9c1 0 1.9-.8 1.9-1.9v-4c0-1-.8-1.9-1.9-1.9H5Zm10 0c-1 0-1.9.8-1.9 1.9V19c0 1 .8 1.9 1.9 1.9H19c1 0 1.9-.8 1.9-1.9v-4c0-1-.8-1.9-1.9-1.9h-4Z" clipRule="evenodd" />
        </svg>
      )
    },
    {
      path: "/partner",
      label: "Partner",
      color: "cyan",
      icon: (
        <svg className="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
          <path fillRule="evenodd" d="M12 2a1 1 0 0 1 1 1v2.1a7.001 7.001 0 0 1 6.364 4.026l.136.31 1.732.866a1 1 0 0 1 .447 1.342l-.447.894-1.732-.866A7.001 7.001 0 0 1 13 18.9V21a1 1 0 1 1-2 0v-2.1a7.001 7.001 0 0 1-6.364-4.026l-.136-.31-1.732-.866a1 1 0 0 1-.447-1.342l.447-.894 1.732.866A7.001 7.001 0 0 1 11 5.1V3a1 1 0 0 1 1-1Zm0 5a5 5 0 1 0 0 10 5 5 0 0 0 0-10Z" clipRule="evenodd" />
        </svg>
      )
    },
    {
      path: "/skills",
      label: "Skills",
      color: "pink",
      icon: (
        <svg className="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
          <path fillRule="evenodd" d="M15 4H9v16h6V4Zm2 16h3a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-3v16ZM4 4h3v16H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2Z" clipRule="evenodd" />
        </svg>
      )
    },
    {
      path: "/games",
      label: "Games",
      color: "emerald",
      icon: (
        <svg className="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
          <path fillRule="evenodd" d="M12 8a1 1 0 0 0-1 1v10H9a1 1 0 1 0 0 2h11c.6 0 1-.4 1-1V9c0-.6-.4-1-1-1h-8Zm4 10a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z" clipRule="evenodd" />
          <path fillRule="evenodd" d="M5 3a2 2 0 0 0-2 2v6h6V9a3 3 0 0 1 3-3h8c.4 0 .7 0 1 .2V5a2 2 0 0 0-2-2H5Zm4 10H3v2c0 1.1.9 2 2 2h4v-4Z" clipRule="evenodd" />
        </svg>
      )
    },
    {
      path: "/pinterest",
      label: "Pinterest",
      color: "indigo",
      icon: (
        <svg className="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
          <path fillRule="evenodd" d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm-1-9h2v2h-2v-2Zm0-4h2v2h-2V7Z" clipRule="evenodd" />
        </svg>
      )
    },
    {
      path: "/nuoitoi",
      label: "Nuoi Toi",
      color: "red",
      icon: (
        <svg className="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
          <path fillRule="evenodd" d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" clipRule="evenodd" />
        </svg>
      )
    },
  ];

  const colorMap = {
    yellow: {
      active: "text-yellow-700 dark:text-yellow-400 border-yellow-500/60",
      inactive: "border-yellow-500/30 text-slate-700 dark:text-slate-400/80",
      pill: "bg-yellow-500/20",
      hover: "hover:bg-yellow-500/15 hover:text-yellow-700 hover:border-yellow-500/50",
      icon: "text-yellow-600 dark:text-yellow-500"
    },
    purple: {
      active: "text-purple-800 dark:text-purple-400 border-purple-600/60",
      inactive: "border-purple-600/30 text-slate-700 dark:text-slate-400/80",
      pill: "bg-purple-600/20",
      hover: "hover:bg-purple-600/15 hover:text-purple-800 hover:border-purple-600/50",
      icon: "text-purple-700 dark:text-purple-600"
    },
    pink: {
      active: "text-pink-800 dark:text-pink-400 border-pink-600/60",
      inactive: "border-pink-600/30 text-slate-700 dark:text-slate-400/80",
      pill: "bg-pink-600/20",
      hover: "hover:bg-pink-600/15 hover:text-pink-800 hover:border-pink-600/50",
      icon: "text-pink-700 dark:text-pink-600"
    },
    emerald: {
      active: "text-emerald-800 dark:text-emerald-400 border-emerald-600/60",
      inactive: "border-emerald-600/30 text-slate-700 dark:text-slate-400/80",
      pill: "bg-emerald-600/20",
      hover: "hover:bg-emerald-600/15 hover:text-emerald-800 hover:border-emerald-600/50",
      icon: "text-emerald-700 dark:text-emerald-600"
    },
    indigo: {
      active: "text-indigo-800 dark:text-indigo-400 border-indigo-600/60",
      inactive: "border-indigo-600/30 text-slate-700 dark:text-slate-400/80",
      pill: "bg-indigo-600/20",
      hover: "hover:bg-indigo-600/15 hover:text-indigo-800 hover:border-indigo-600/50",
      icon: "text-indigo-700 dark:text-indigo-600"
    },
    red: {
      active: "text-red-700 dark:text-red-400 border-red-500/60",
      inactive: "border-red-500/30 text-slate-700 dark:text-slate-400/80",
      pill: "bg-red-500/20",
      hover: "hover:bg-red-500/15 hover:text-red-700 hover:border-red-500/50",
      icon: "text-red-600 dark:text-red-500"
    },
    cyan: {
      active: "text-cyan-800 dark:text-cyan-400 border-cyan-600/60",
      inactive: "border-cyan-600/30 text-slate-700 dark:text-slate-400/80",
      pill: "bg-cyan-600/20",
      hover: "hover:bg-cyan-600/15 hover:text-cyan-800 hover:border-cyan-600/50",
      icon: "text-cyan-700 dark:text-cyan-600"
    }
  };

  const getNavItemStyle = (item) => {
    const baseStyle = "relative flex gap-1.5 px-2.5 py-1.5 rounded-lg border transition-all duration-300 items-center justify-center font-semibold text-xs sm:text-sm z-10 active:scale-95";
    const isActivePath = isActive(item.path);
    const theme = colorMap[item.color] || { active: "", inactive: "", hover: "", icon: "" };

    if (isActivePath) {
      return `${baseStyle} ${theme.active} shadow-lg shadow-current/10`;
    }
    return `${baseStyle} ${theme.inactive} ${theme.hover}`;
  };

  return (
    <div className="relative z-20 p-2 sm:p-2.5 rounded-xl shadow-xl bg-white/40 dark:bg-slate-900/60 backdrop-blur-xl border border-white/20 dark:border-slate-800/50 transition-all duration-500">
      {/* Desktop Navigation */}
      <div className="hidden md:flex justify-between items-center">
        <div className="flex gap-2 items-center relative">
          {navItems.map((item) => (
            <Link key={item.path} to={item.path} className="relative">
              <div className={getNavItemStyle(item)}>
                {item.label}
                <span className={colorMap[item.color]?.icon}>{item.icon}</span>

                {isActive(item.path) && (
                  <motion.div
                    layoutId="active-pill"
                    className={`absolute inset-0 rounded-lg ${colorMap[item.color]?.pill} -z-10`}
                    transition={{ type: "spring", bounce: 0.25, duration: 0.5 }}
                  />
                )}
              </div>
            </Link>
          ))}
        </div>
        <div className="ml-2 pl-2 border-l border-slate-200 dark:border-slate-800">
          <SettingsToggle />
        </div>
      </div>

      {/* Mobile Navigation */}
      <div className="md:hidden">
        <div className="flex justify-between items-center">
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="p-2.5 rounded-xl bg-slate-200/50 dark:bg-slate-800/50 text-slate-800 dark:text-slate-200 border border-slate-300 dark:border-slate-700 shadow-sm relative"
          >
            <FaTimes size={18} className={`transition-transform duration-300 ${isMenuOpen ? "scale-100 rotate-0" : "scale-0 rotate-90 absolute"}`} />
            <FaBars size={18} className={`transition-transform duration-300 ${!isMenuOpen ? "scale-100 rotate-0" : "scale-0 -rotate-90 absolute"}`} />
          </button>

          <div className="flex items-center gap-2">
            <span className="text-sm font-black uppercase tracking-widest text-slate-700 dark:text-slate-400">
              {navItems.find((item) => isActive(item.path))?.label || "Menu"}
            </span>
            <SettingsToggle />
          </div>
        </div>

        {/* Mobile Menu Dropdown */}
        <AnimatePresence>
          {isMenuOpen && (
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
              className="mt-4 pt-4 border-t border-slate-200/50 dark:border-slate-700/50 overflow-hidden"
            >
              <div className="grid grid-cols-2 gap-3 pb-2">
                {navItems.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    onClick={() => setIsMenuOpen(false)}
                    className="relative"
                  >
                    <div className={getNavItemStyle(item)}>
                      <span className={colorMap[item.color]?.icon}>{item.icon}</span>
                      {item.label}

                      {isActive(item.path) && (
                        <motion.div
                          layoutId="active-pill-mobile"
                          className={`absolute inset-0 rounded-lg ${colorMap[item.color]?.pill} -z-10`}
                          transition={{ type: "spring", bounce: 0.2, duration: 0.5 }}
                        />
                      )}
                    </div>
                  </Link>
                ))}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}

export default Nav;
